import { useEffect, useState } from 'react'

const supportedIcons = ['calendar', 'celebration', 'email', 'exclamation_point', 'work']

type IconName = (typeof supportedIcons)[number]

type DynamicIconProps = {
  name: IconName
}

const DynamicIcon = ({ name }: DynamicIconProps) => {
  if (!supportedIcons.includes(name)) return null

  const [svgContent, setSvgContent] = useState<string>('')

  useEffect(() => {
    fetch(`/assets/${name}.svg`)
      .then(res => res.text())
      .then(text => {
        // @TODO: Impliment normalization to currentColor
        // const safeSvg = text.replace(/fill="[^"]*"/g, 'fill="currentColor"')
        setSvgContent(text)
      })
  }, [name])

  return <span dangerouslySetInnerHTML={{ __html: svgContent }} />
}

export default DynamicIcon
